import { render } from "./CatalogItem.vue?vue&type=template&id=1225d0cc"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"

import "./CatalogItem.vue?vue&type=style&index=0&id=1225d0cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__